import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';

interface TeamMember {
  name: string;
  role: string;
  photo: string;
}

@Component({
  selector: 'app-about',
  imports: [CommonModule],
  templateUrl: './about.component.html',
  styleUrl: './about.component.scss',
})
export class AboutComponent implements OnInit {
  team: TeamMember[] = [];

  ngOnInit(): void {
    // Sample team data; update with real info
    this.team = [
      {
        name: 'Anthony',
        role: 'Gas Safe Engineer',
        photo: '/images/team/tony.png',
        // photo: '/images/team/tony.jpg', //Real image
      },
      {
        name: 'Lauren',
        role: 'Call Centre Manager',
        photo: '/images/team/lauren.jpeg',
      },
      {
        name: 'Angelo',
        role: 'Online Response Manager',
        photo: '/images/team/gelo.png',
      },
    ];
  }
}
